import { useDispatch } from 'react-redux';
import adminOffersApi, {
  useRemoveAllBidsMutation,
  useRemoveAllOffersMutation,
  useRemoveOfferBidMutation,
  useRemoveProxyOfferBidMutation,
  useUpdateOfferBidMutation,
  useUpdateProxyOfferBidMutation
} from 'services/api/admin-offers';

import { editBid, editProxyBid, deleteBid, deleteProxyBid } from '../../../../../../actions/bids';
import {
  useEditAlternativeBidOfferMutation,
  useRemoveAllAlternativeBidOffersMutation,
  useRemoveAlternativeBidOfferMutation
} from '../../../../../../services/api/alternative-offers';

export const useActions = (type: string) => {
  const dispatch = useDispatch();

  const [removeOfferBid] = useRemoveOfferBidMutation();
  const [removeProxyOfferBid] = useRemoveProxyOfferBidMutation();
  const [updateOfferBid] = useUpdateOfferBidMutation();
  const [updateProxyOfferBid] = useUpdateProxyOfferBidMutation();
  const [removeAllOffers] = useRemoveAllOffersMutation();
  const [removeAllBidsMutation] = useRemoveAllBidsMutation();

  const [editAlternativeBidOffer] = useEditAlternativeBidOfferMutation();
  const [removeAlternativeBidOffer] = useRemoveAlternativeBidOfferMutation();
  const [removeAllAlternativeOffersMutation] = useRemoveAllAlternativeBidOffersMutation();

  const actionMap = {
    bids: {
      removeBid: (payload: any) => dispatch(deleteBid(payload).request),
      removeProxyBid: (payload: any) => dispatch(deleteProxyBid(payload).request),
      updateBid: (payload: any) => dispatch(editBid(payload).request),
      updateProxyBid: (payload: any) => dispatch(editProxyBid(payload).request),
      removeAllBids: removeAllBidsMutation
    },
    offers: {
      removeBid: removeOfferBid,
      removeProxyBid: removeProxyOfferBid,
      updateBid: updateOfferBid,
      updateProxyBid: updateProxyOfferBid,
      removeAllBids: removeAllOffers
    },
    alternativeOffers: {
      removeBid: removeAlternativeBidOffer,
      removeProxyBid: removeAlternativeBidOffer,
      updateBid: editAlternativeBidOffer,
      updateProxyBid: editAlternativeBidOffer,
      removeAllBids: removeAllAlternativeOffersMutation
    }
  };

  return actionMap[type as keyof typeof actionMap];
};
